'use client'
import {
  Button_default
} from "./chunk-KPHPJUNU.mjs";
import {
  NotifyButton_default
} from "./chunk-WZIEBXDX.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";

// src/components/brackets/BracketsOrganization.tsx
import { useMemo } from "react";
import { useEventsList, useGetOrganizationBySlug } from "@wbk/api/hooks";
import { CurrencyPriceLabel } from "@wbk/currency";
import { Link, useRouter, useTranslation } from "@wbk/config";
import { Brackets, BracketsLoader, Button, Typography } from "@wbk/ui";
import { formatDate } from "@wbk/utils";
import { jsx, jsxs } from "react/jsx-runtime";
var BracketsOrganization = ({ section }) => {
  var _a;
  const { locale } = useRouter();
  const { t } = useTranslation("contentful_event");
  const organizationSlug = section.organizationSlug;
  const {
    data: orgData,
    isLoading: orgLoading,
    error: orgError
  } = useGetOrganizationBySlug(
    {
      lang: locale,
      slug: organizationSlug
    },
    {
      enabled: !!organizationSlug
    }
  );
  const {
    data: eventsData,
    isLoading: eventsLoading,
    error: eventsError
  } = useEventsList(
    {
      lang: locale,
      publicOnly: true,
      organizationSlug: organizationSlug != null ? organizationSlug : ""
    },
    {
      enabled: !!organizationSlug
    }
  );
  const groups = useMemo(() => {
    var _a2;
    if (!eventsData || !orgData) return [];
    const events = eventsData.events || [];
    const bracketGroups = ((_a2 = orgData.event_groups) == null ? void 0 : _a2.filter((g) => g.slug.includes("-brackets"))) || [];
    return bracketGroups.map((group) => {
      const groupedEvents = events.filter((ev) => ev.event_group_id === group._id);
      const items = groupedEvents.map((event) => {
        var _a3, _b, _c, _d, _e, _f, _g;
        return {
          id: event._id,
          title: event.start_date_time ? `${formatDate(new Date(event.start_date_time), `${locale}-GB`, {
            weekday: "short",
            day: "numeric",
            month: "short"
          })} - ${formatDate(new Date(event.start_date_time), `${locale}-GB`, {
            hour: "2-digit",
            minute: "2-digit"
          })}` : t("contentful_event:tbd"),
          subtitle: ((_a3 = event.venue) == null ? void 0 : _a3.name) || t("contentful_event:tbd"),
          teams: [
            {
              name: ((_b = event.home_team) == null ? void 0 : _b.name) || t("contentful_event:tbd"),
              icon: (_c = event.home_team) == null ? void 0 : _c.logo,
              score: ((_d = event.home_team) == null ? void 0 : _d.score) ? Number(event.home_team.score) : void 0
            },
            {
              name: ((_e = event.away_team) == null ? void 0 : _e.name) || t("contentful_event:tbd"),
              icon: (_f = event.away_team) == null ? void 0 : _f.logo,
              score: ((_g = event.away_team) == null ? void 0 : _g.score) ? Number(event.away_team.score) : void 0
            }
          ],
          button: !event ? void 0 : event.is_notify_me_enabled ? /* @__PURE__ */ jsx(
            NotifyButton_default,
            {
              className: "py-S min-h-0 w-fit",
              textVariant: "body-S",
              shape: "outlined",
              theme: "action",
              event: {
                __typename: "event",
                id: event._id,
                title: event.title,
                slug: event.slug
              }
            }
          ) : event.resale_status ? /* @__PURE__ */ jsx(
            Button_default,
            {
              slug: event.slug,
              theme: "action",
              className: "w-fit",
              title: /* @__PURE__ */ jsx(Typography, { variant: "body-S", strong: true, children: t("contentful_event:resell.check_tickets") })
            }
          ) : /* @__PURE__ */ jsxs("div", { className: "space-y-XS", children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-1.5", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "label-S", color: "text-secondary", children: t("contentful_event:from") }),
              /* @__PURE__ */ jsx(
                CurrencyPriceLabel,
                {
                  originalPrice: event.event_start_price + event.event_start_vat,
                  currency: event.currency,
                  className: "text-text font-semibold"
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                as: Link,
                to: `/${locale}/events/${event.slug}`,
                theme: "primary",
                className: "w-full",
                children: /* @__PURE__ */ jsx(Typography, { variant: "body-S", strong: true, children: t("contentful_event:book_now") })
              }
            )
          ] })
        };
      });
      return {
        name: group.title,
        items
      };
    });
  }, [orgData, eventsData, locale]);
  if (orgError || eventsError || !groups || !groups.length || !organizationSlug) return null;
  return /* @__PURE__ */ jsx(DecoratedSection_default, { section, children: /* @__PURE__ */ jsxs("div", { className: "container-1/2", children: [
    section.title && /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
      section.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", className: "mt-1", children: section.subtitle })
    ] }),
    orgLoading || eventsLoading ? /* @__PURE__ */ jsx(BracketsLoader, {}) : /* @__PURE__ */ jsx(Brackets, { groups, image: (_a = section.logo) == null ? void 0 : _a.url })
  ] }) });
};
var BracketsOrganization_default = BracketsOrganization;

export {
  BracketsOrganization_default
};
//# sourceMappingURL=chunk-MYNKRLWP.mjs.map